import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { AutomapperService } from "../../../../../../core/automapper/automapper.service";
import { BASE_API_URL } from "../../../../../../core/environment.tokens";
import { NumberHelper } from "../../../../../../utilities/contracts/number-helper";
import { MemberSearchResult } from "../../../../member/create-new-chase/create-new-chase-member/member-search-result.model";
import { AuditQueryGridFilters } from "./audit-query-grid-filter-model";
import { IAuditQueryGridData } from "./member-radv-record.model";
import { IMemberSearchCriteria } from "./member-search-criteria.model";

@Injectable({
  providedIn: "root",
})
export class AuditQueryGridFiltersService {
  private gridFilters = new BehaviorSubject<AuditQueryGridFilters>(new AuditQueryGridFilters());
  auditGridFilter = this.gridFilters.asObservable();

  constructor(
    private http: HttpClient,
    @Inject(BASE_API_URL) private readonly baseApiUrl: string,
    private readonly automapper: AutomapperService
  ) { }

  resetGridFilter(value: AuditQueryGridFilters) {
    this.gridFilters.next(value);
  }

  getMembersList(searchCriteria: IMemberSearchCriteria): Observable<MemberSearchResult[]> {
    const url = `${this.baseApiUrl}member/search`;

    return this.http.post<MemberSearchResult[]>(url, searchCriteria)
      .pipe(
        map(this.automapper.curryMany("default", "MemberSearchResult")),
        catchError(error => {
          console.error("Error fetching members list:", error);
          throw error;
        })
      );
  }

  getMemberRadvCard(memberId: number): Observable<IAuditQueryGridData[]> {
    const url = `${this.baseApiUrl}member/radvcard?memberId=${memberId}`;

    return this.http.get<any[]>(url)
      .pipe(
        map((records: any[]) => {
          const mappedRecords = records.map(record => {
            const transformedRecord = {
              ...record,
            };
            return transformedRecord as IAuditQueryGridData;
          });
          return mappedRecords;
        }),
        catchError(error => {
          console.error("Error fetching member RADV card:", error);
          throw error;
        })
      );
  }

}
